import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createRouter, createWebHistory } from 'vue-router'
import { sync } from 'vuex-router-sync'
import routes from './auth/routes'
import store from './auth/store'
import validator from './validator'
import messages from './front/trans.en.js'

import axios from 'axios'
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementsByTagName("meta")['csrf-token'].getAttribute('content')

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
Bugsnag.start({ apiKey: 'b3ec68154b90832d01d171fb97a22d1e', plugins: [new BugsnagPluginVue()] })
const bugsnag = Bugsnag.getPlugin('vue')

window.analytics = require('./analytics.js')

window.parseError = function (error) {
    if (window.location.href.indexOf('pfp.five') !== -1) { console.error(error) }
    let code = error && error.response && error.response.status ? error.response.status : -1
    if (code > -1) {
        let ignore = [401, 403, 419, 422]
        if ((window.axios && !window.axios.isCancel(error)) && ignore.indexOf(code) === -1) {
            Bugsnag.notify(error)
        }
    }
    let message = error && error.response && error.response.data ? error.response.data : ''
    if (code == 422 && message && message.message) {
        try {
            let title = message.message
            let description = message.errors ? message.errors[Object.keys(message.errors)[0]].join(" ") : ''
            return {
                title: title,
                description: description != title ? description : ''
            }
        } catch (err) {
            return ''
        }
    }
    return message
}


const _timeout = 1000 * 60 * 60 * 1
let _timer = null

const _timeoutHandler = function () {
    console.log('Keep alive reload.')
    window.location.reload()
}
const _timeoutReset = function () {
    clearTimeout(_timer)
    _timer = window.setTimeout(_timeoutHandler, _timeout)
}

_timeoutReset()

const router = createRouter({ history: createWebHistory(), linkExactActiveClass: 'active', routes: routes })
const i18n = createI18n({ legacy: true, locale: 'en', messages: messages })
const app = createApp({})

sync(store, router)

app.use(store)
app.use(router)
app.use(i18n)
app.use(validator)
app.use(bugsnag)

import hAlert from './components/Alert'
import hButton from './components/Button'
import hIcon from './components/Icon'
import hLoader from './components/Loader'
import hPassword from './components/Password'
import hPhone from './components/FieldPhone'
import hSplash from './auth/Splash.vue'

app.component('app--alert', hAlert)
app.component('app--button', hButton)
app.component('app--icon', hIcon)
app.component('app--loader', hLoader)
app.component('app--password', hPassword)
app.component('app--phone', hPhone)
app.component('auth--splash', hSplash)

app.mount('#app')

window.store = store
